export default __webpack_public_path__ + "static/media/irq.c18b2ef8.svg";